// Signup: the plan list could not be read (saas/Signup.jsx, `plansFailed`).
export default {
  fr: {
    "signup.plansLoadFailed": "Impossible de charger les forfaits pour le moment.",
    "signup.plansRetry": "Réessayer",
  },
  en: {
    "signup.plansLoadFailed": "The plans could not be loaded right now.",
    "signup.plansRetry": "Try again",
  },
  es: {
    "signup.plansLoadFailed": "No se pudieron cargar los planes en este momento.",
    "signup.plansRetry": "Reintentar",
  },
};
